import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Autocomplete, Button, Divider, Stack, TextField, Typography } from "@mui/material"
import { PrincipalLayouts } from "../../../layouts"
import { Field } from "../miProfile/Field";
import { useForm } from "../../../hooks";
import { useNavigate } from "react-router-dom";
import { addVehicle } from "../../helpers/vehicle";
import { DateInput } from "../DateInput";

const optionsModality = ['Clubs', 'Fondos']
const optionsHoldings = ['Faraday Venture Partners SL', 'Faraday Venture Capital SGEIC SA de CV', 'Faraday Oportunidad I, SL', 'Faraday Oportunidad II, SL', 'Faraday Oportunidad III, SL', 'Faraday Oportunidad IV, SL' ]

export const AddVehicle = () => {

    const { t } = useTranslation('global');
    const navigate = useNavigate();
    const [isWaiting, setIsWaiting] = useState(false);
    const [formValues, handleInputChange, reset] = useForm({ name: '', key: '', created: '', modality: optionsModality[0], holding: 'Faraday Venture Partners SL', address: '', zipCode: '' });

    const { name, key, created, modality, holding, address, zipCode } = formValues;

    const handleConfirm = async (e) => {
        e.preventDefault();
        setIsWaiting(true)
        await addVehicle(formValues, t('addvehicle.succesMsg'), t('addvehicle.errorMsg'), t('addvehicle.dupNameMsg'), navigate)
        setIsWaiting(false)
        reset()
    }
    const handleCancel = () => {
        reset();
        navigate('/vehicle')
    }

    return (
        <PrincipalLayouts>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Typography color='primary' variant='h5'>{t('addvehicle.titlePage')}</Typography>
            </Stack>
            <Divider sx={{ marginTop: 2, marginBottom: 3 }} />

            <form onSubmit={handleConfirm}>
                <Stack minHeight='calc(100vh - 290px)' gap={2}>

                    <Stack direction='row' width='100%' gap={2}>
                        <Field translation='vehiclestable' name={name} title='name' handleInputChange={handleInputChange} required={true} />
                        <Field translation='vehiclestable' name={key} title='key' handleInputChange={handleInputChange} />
                    </Stack>

                    <Field translation='vehiclestable' name={address} title='address' handleInputChange={handleInputChange} />

                    <Stack direction='row' width='100%' gap={2}>
                        <DateInput name={created} title='created' handleInputChange={handleInputChange} required={true} />
                        <Field translation='vehiclestable' name={zipCode} title='zipCode' handleInputChange={handleInputChange} />
                    </Stack>

                    <Stack width='100%' padding='0 5px'>
                        <Typography variant='overline' color='secondary'>{t('vehiclestable.holding')}</Typography>
                        <Autocomplete
                            disablePortal
                            options={optionsHoldings}
                            size='small'
                            renderInput={(params) => <TextField  {...params} variant='outlined' name='holding' />}
                            value={holding}
                            onSelect={handleInputChange}
                            required
                        />
                    </Stack>
                    <Stack width='100%' padding='0 5px'>
                        <Typography variant='overline' color='secondary'>{t('vehiclestable.modality')}</Typography>
                        <Autocomplete
                            disablePortal
                            options={optionsModality}
                            size='small'
                            renderInput={(params) => <TextField  {...params} variant='outlined' name='modality' />}
                            value={modality}
                            onSelect={handleInputChange}
                            required
                        />
                    </Stack>
                </Stack>

                <Stack direction='row' justifyContent='end' gap={2} marginTop={3}>
                    <Button sx={{ width: '140px' }} color='secondary' onClick={handleCancel} variant="outlined">{t('myprofile.cancelButton')}</Button>
                    <Button disabled={isWaiting} sx={{ width: '140px' }} type='submit' variant="contained">{t('myprofile.confirmButton')}</Button>
                </Stack>
            </form>

        </PrincipalLayouts>
    )
}